import { type ComponentType, type ElementType } from "react";
import { type TBadgeColor } from "@components/Badge/Badge";

export enum AddBillMethod {
  BANK = "bank",
  EMAIL = "email",
  MANUAL = "manual",
  PDF = "pdf",
}

export interface IAddBillVariantMethodButtonProps {
  badgeIcon: ComponentType | ElementType;
  badgeColor?: TBadgeColor;
  variant: AddBillMethod;
  selectedMethod: AddBillMethod | null;
  onClick: () => void;
  className?: string;
}
